<div class="card fluid">
    <div class="card__content">
      <div class="width-full p-5 text-center gap-20">
        <span class="delete-text">
          <i class="fas fa-trash"></i>
          Sure you want to delete this item?
        </span>
        <span>
          <button (click)="cancel()" id="" title="Cancel"
            class="mr-10 display-inline-block  secondary border-red rounded-full hover-red hover-font-white flex-row-reverse">
            <div class="btn-txt font-red bold">No Cancel</div>
          </button>
          <button (click)="delete()" title="Delete" class="display-inline-block rounded-full hover-blue-800 black">
            <div class="btn-txt font-white">Yes Delete</div>
          </button>
        </span>
      </div>
    </div>
  </div>
